import { Fields, FormOption } from 'common/form';
import { SelectWorkflowFormData } from 'modules/candidate-profile/forms/schema/selectWorkflowSchema';

type GetSelectWorkflowFieldsProps = {
  onSearchFilter: (query: string) => Promise<FormOption[]>;
  /** Sits under the label: the way out to the builder when the list is missing a workflow. */
  manageLink: JSX.Element;
  /** Opens the chosen workflow. Absent until one is chosen. */
  viewWorkflowLink?: JSX.Element;
};

export const getSelectWorkflowFields = ({
  onSearchFilter,
  manageLink,
  viewWorkflowLink
}: GetSelectWorkflowFieldsProps): Fields<SelectWorkflowFormData> => ({
  workflowId: {
    type: 'server-dropdown',
    label: 'Choose a workflow',
    subLabel: manageLink,
    endAdornment: viewWorkflowLink,
    onSearchFilter,
    searchPlaceholder: 'Search by workflow title...',
    buttonText: 'Choose',
    popperSx: {
      zIndex: 1401
    }
  }
});
